import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep } from '../OwnershipTransferSlice';
import BtnBlackBorder from '../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import { OwnershipTransferStep, RequestExecutedByDescription, OwnershipTransferActionTypeDescription, RequestStatusDescription } from '../Constant/Constant';
import { plus } from '../Icons/svgIcons';
import DashboardTableRow from './DashboardTableRow';
import DashboardTableTitle from './DashboardTableTitle';
import TextInput from '../../../Shared/TextInput/TextInput';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhDashboardReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'
import { saveAs } from 'file-saver';
import Papa from 'papaparse';

const Dashboard = (props) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredDashboardData, setFilteredDashboardData] = useState(props.data.dashboardData);
  const [isDescending, setIsDescending] = useState(true);

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhDashboardReport({
        data: { userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.StatusTable,
        messageText: DWHMessageText.StatusTablePageDisplayed,
        status: DWHStatus.Ongoing,

      });
    }
  }, []);

  useEffect(() => {
    setFilteredDashboardData(props.data.dashboardData);
    if (searchQuery) {
      handleSearchChange(searchQuery, props.data.dashboardData);
    }
  }, [props.data.dashboardData]);

  const handleSearchChange = (value, data = props.data.dashboardData) => {
    setSearchQuery(value);
    if (value) {
      const filteredData = data.filter(row => {
        const subscriberIdNumber = String(row.subscriberIdNumber);
        return (
          subscriberIdNumber.includes(value) ||
          row.subscriberFirstName.includes(value) ||
          row.subscriberLastName.includes(value) ||
          row.subscriberPhoneNumber.includes(value)
        );
      });
      setFilteredDashboardData(filteredData);
    } else {
      setFilteredDashboardData(props.data.dashboardData);
    }
  };

  function reorderRows() {
    const sortedData = [...filteredDashboardData].sort((a, b) => {
      if (isDescending) {
        return a.id - b.id;
      } else {
        return b.id - a.id;
      }
    });
    setFilteredDashboardData(sortedData);
    setIsDescending(!isDescending);
  }

  function createNewRequest() {
    dwhDashboardReport({
      data: { userDetails: props.userDetails, portalsBlock: props.portalsBlock },
      actionType: DwhActionType.StatusTable,
      messageText: DWHMessageText.StatusTableNewTransferButtonClicked,
      status: DWHStatus.Ongoing,
    });
    props.setCurrentStep(OwnershipTransferStep.SelectActionType)
  }

  const downloadCSV = () => {
    const formattedData = filteredDashboardData.map(item => ({
      'תאריך שליחה': new Date(item.createData).toLocaleDateString('he-IL'),
      'שם מנוי': `${item.subscriberFirstName} ${item.subscriberLastName}`,
      'ת.ז מנוי': item.subscriberIdNumber,
      'מספר מנוי': item.subscriberPhoneNumber,
      'סוג העברת בעלות': OwnershipTransferActionTypeDescription[item.actionType],
      'בוצע על ידי': RequestExecutedByDescription[item.requestExecutedBy],
      'בדיקת סטטוס ופעולות': RequestStatusDescription[item.statusCodeDescription]
    }));
    // Convert JSON to CSV
    const csv = Papa.unparse(formattedData);
    const csvWithBOM = '\uFEFF' + csv;
    const blob = new Blob([csvWithBOM], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, 'העברת בעלות.csv');

  };

  return (
    <div className='ownership-transfer-dashboard'>
      <div className='l-title mb-40'>סטטוס העברת בעלות</div>
      <div className='dashboard-table-container'>
        <div className='dashboard-table-top-container'>
          <div className='dashboard-table-search'>
            <TextInput
              value={searchQuery}
              id='search'
              placeholder={'חיפוש מנוי לפי שם, מס׳ תז או מס׳ טלפון'}
              onChange={(e) => {
                handleSearchChange(e.target.value)
              }}
            />
            <div><Image src={require('../Icons/search.svg')} /></div>
          </div>

          <div className='add-new-request'>
            <button className='download-csv-btn' onClick={downloadCSV}><Image src={require('../Icons/download.svg')} /></button>
            <BtnBlackBorder
              svgImage={plus}
              text='העברת בעלות חדשה'
              onclick={() => createNewRequest()}
            />
          </div>
        </div>
        <div className='dashboard-table'>
          <div><DashboardTableTitle reorderRows={reorderRows} /></div>
          <div className="dashboard-table-rows">
            {filteredDashboardData?.length === 0 ?
              <div className='no-data'>
                <Image src={require('../Icons/error.svg')} />

                <div className='semi'>לא נמצאו תוצאות שתואמות את החיפוש</div>
                <div>״{searchQuery}״</div>
              </div>
              :
              <div>{filteredDashboardData?.map((row, index) => <DashboardTableRow row={row} key={index} getEquipmentTitle={props.getEquipmentTitle} />)}</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  userDetails: state.authentication?.loginData?.userDetails,
  portalsBlock: state.portalsBlock,
});

const mapDispatchToProps = {
  setCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
